import { render, staticRenderFns } from "./RealisticHD.vue?vue&type=template&id=4a6d7ea1&scoped=true"
import script from "./RealisticHD.vue?vue&type=script&lang=js"
export * from "./RealisticHD.vue?vue&type=script&lang=js"
import style0 from "./RealisticHD.vue?vue&type=style&index=0&id=4a6d7ea1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6d7ea1",
  null
  
)

export default component.exports